// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_DocumentCreation from "../Ouroboros.Programs.Controllers.DocumentCreation/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var mkDocumentCreationEnv = function (input) {
    return {
        loading: input.kernel.loading,
        lifecycle: input.kernel.lifecycle,
        document: input.kernel.document,
        availableDocuments: input.kernel.availableDocuments,
        navigate: input.kernel.navigate,
        documentDetailsPromptRoute: input.kernel.documentDetailsPromptRoute,
        taskRunner: input.kernel.taskRunner,
        documentSelectionRoute: input.documentSelectionRoute
    };
};
var buildDocumentCreationViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentCreation.mkDocumentCreationController(mkDocumentCreationEnv(input));
    return {
        availableDocuments: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.availableDocuments)),
        onInit: Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Controllers_DocumentCreation.runDocumentCreationAction(controller.onInit)),
        onCreateDocument: function (request) {
            return Ouroboros_Programs_Controllers_DocumentCreation.runDocumentCreationAction(controller.onCreateDocument(request));
        }
    };
};
export {
    buildDocumentCreationViewProps
};
//# sourceMappingURL=index.js.map
